import React, { JSX } from 'react';
import { ApplicantOfferRequirementTask } from 'types';
import BaseFulfilmentDataRenderer, { FulfilmentRendererProps } from './BaseFulfilmentDataRenderer';
import CalendlyInterviewFulfilmentRenderer from './CalendlyInterviewFulfilmentRenderer';
import EnglishLanguageResultsFulfilmentRenderer from './EnglishLanguageResultsFulfilmentRenderer';
import RecordedInterviewFulfilmentRenderer from './RecordedInterviewFulfilmentRenderer';
import RefereeDetailsFulfilmentRenderer from './RefereeDetailsFulfilmentRenderer';
import PaymentFulfilmentRenderer from './PaymentFulfilmentRenderer';

const fulfilmentRendererMap: Partial<
  Record<ApplicantOfferRequirementTask, React.ComponentType<FulfilmentRendererProps>>
> = {
  [ApplicantOfferRequirementTask.CalendlyInterview]: CalendlyInterviewFulfilmentRenderer,
  [ApplicantOfferRequirementTask.EnglishLanguageResults]: EnglishLanguageResultsFulfilmentRenderer,
  [ApplicantOfferRequirementTask.RecordedInterview]: RecordedInterviewFulfilmentRenderer,
  [ApplicantOfferRequirementTask.RefereeDetails]: RefereeDetailsFulfilmentRenderer,
  [ApplicantOfferRequirementTask.Payment]: PaymentFulfilmentRenderer,
};

interface FulfilmentRendererFactoryProps extends FulfilmentRendererProps {
  requirementId: string;
  // taskType is used for map lookup when requirementId is composite (e.g. 'CalendlyInterview#uuid')
  taskType?: ApplicantOfferRequirementTask;
}

export default function FulfilmentRendererFactory(props: FulfilmentRendererFactoryProps): JSX.Element {
  const { requirementId, taskType } = props;

  // Use taskType for lookup when provided, otherwise fall back to requirementId.
  // taskType is needed for composite IDs (e.g. CalendlyInterview#uuid) where
  // requirementId does not match the map key directly.
  const lookupKey = taskType ?? (requirementId as ApplicantOfferRequirementTask);
  const RendererComponent = fulfilmentRendererMap[lookupKey] ?? BaseFulfilmentDataRenderer;

  return <RendererComponent {...props} />;
}
